import { render, staticRenderFns } from "./PersonalizationMicrosoftModal.vue?vue&type=template&id=e1b622c4&scoped=true"
import script from "./PersonalizationMicrosoftModal.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftModal.vue?vue&type=style&index=0&id=e1b622c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b622c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b622c4')) {
      api.createRecord('e1b622c4', component.options)
    } else {
      api.reload('e1b622c4', component.options)
    }
    module.hot.accept("./PersonalizationMicrosoftModal.vue?vue&type=template&id=e1b622c4&scoped=true", function () {
      api.rerender('e1b622c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/microsoft/PersonalizationMicrosoftModal.vue"
export default component.exports